/**
 * Chrome-only Private Network Access option: loopback for a localhost server
 * (dev, tests, sandbox preview), else local; undefined where unsupported.
 */
export function getTargetAddressSpace(
  serverUrl: string,
): "loopback" | "local" | undefined {
  if (typeof Request === "undefined") {
    return undefined;
  }

  try {
    // Safari, Brave, and Firefox throw TypeError on this unknown option.
    // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
    new Request("data:,", { targetAddressSpace: "loopback" } as RequestInit);
  } catch {
    return undefined;
  }

  const testTypes = ["e2e_test", "pe2e_test"];
  const isTest = testTypes.includes(process.env.TEST_TYPE || "");
  const isLocalDev = process.env.NODE_ENV === "development";
  return isTest || isLocalDev || isLoopbackUrl(serverUrl)
    ? "loopback"
    : "local";
}

const LOOPBACK_HOSTNAMES = new Set(["localhost", "127.0.0.1", "[::1]"]);

function isLoopbackUrl(url: string): boolean {
  let hostname: string;
  try {
    hostname = new URL(url).hostname;
  } catch {
    return false;
  }
  return LOOPBACK_HOSTNAMES.has(hostname) || hostname.endsWith(".localhost");
}
